import { useMemo } from "react";
import { useAuth } from "../App";
import { Users2 } from "lucide-react";
import { ReporteTaquillaVsOnline } from "./ReportesPage";

export default function ReporteCanalPage() {
  const { token, API, hasPermission } = useAuth();
  const canExport = hasPermission ? hasPermission("reportes.exportar") : true;
  const auth = useMemo(() => ({ headers: { Authorization: `Bearer ${token}` } }), [token]);

  return (
    <div className="p-4 md:p-8 space-y-6" data-testid="page-rep-canal">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-green-100 text-green-800"><Users2 className="w-6 h-6" /></div>
        <div>
          <h1 className="font-display font-bold text-2xl text-green-900">Pagos en Taquilla vs Online</h1>
          <p className="text-sm text-green-700/70">Comparativa de pagos gestionados por funcionarios vs reportados por contribuyentes desde el portal</p>
        </div>
      </div>
      <ReporteTaquillaVsOnline auth={auth} API={API} canExport={canExport} />
    </div>
  );
}
